export const SET_INVOICE = 'setInvoice'
export const SET_INVOICE_PAGINATION = 'setInvoicePagination'
